// Stimulus 컨트롤러 등록
// 경량 컨트롤러만 메인 번들에 포함
// 무거운 컨트롤러(exam, insurance)는 별도 JS 파일로 분리 → 해당 페이지에서만 로드

import { application } from "./application"

// --- 전역 경량 컨트롤러 ---
import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

// AI Assistant 채팅 (ActionCable consumer 포함, /ai-assistant 페이지 전용이지만 경량)
import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import UtmBannerController from "./utm_banner_controller"
application.register("utm-banner", UtmBannerController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

// Sprint #2-C — 토픽 행동 이벤트 3종 추적 (scroll/time/faq)
import TopicTelemetryController from "./topic_telemetry_controller"
application.register("topic-telemetry", TopicTelemetryController)

// P9 Norman Information Scent — 토픽 본문 끝 "다음 단계" 카드 클릭 계측
import NextActionController from "./next_action_controller"
application.register("next-action", NextActionController)

import HomeBookmarkController from "./home_bookmark_controller"
application.register("home-bookmark", HomeBookmarkController)

import HomePriceController from "./home_price_controller"
application.register("home-price", HomePriceController)

import HomeSearchController from "./home_search_controller"
application.register("home-search", HomeSearchController)

import HomeQuizController from "./home_quiz_controller"
application.register("home-quiz", HomeQuizController)

import MermaidController from "./mermaid_controller"
application.register("mermaid", MermaidController)

import GuideAudioController from "./guide_audio_controller"
application.register("guide-audio", GuideAudioController)

import GuideFlashcardController from "./guide_flashcard_controller"
application.register("guide-flashcard", GuideFlashcardController)

import GuideComicController from "./guide_comic_controller"
application.register("guide-comic", GuideComicController)

import TravelCalculatorController from "./travel_calculator_controller"
application.register("travel-calculator", TravelCalculatorController)

import ContractFlowController from "./contract_flow_controller"
application.register("contract-flow", ContractFlowController)

import ToolsFilterController from "./tools_filter_controller"
application.register("tools-filter", ToolsFilterController)

import DropdownNavController from "./dropdown_nav_controller"
application.register("dropdown-nav", DropdownNavController)

// --- 무거운 컨트롤러는 별도 entrypoint로 분리 ---
// exam_controllers.js → 모의고사 페이지에서 javascript_include_tag "exam_controllers"
// insurance_controller.js → 보험계산기 페이지에서 javascript_include_tag "insurance_controller"
// ExamProgressController는 exam_progress.js (이미 별도 entrypoint)
